import { useGetFrontTipiUtente } from '@framework/api-client';
import { recipientCodeByLegalEntityType } from '@framework/common-web';
import { useMemo } from 'react';
import { useSelectedLegalEntity } from '../../../../components/legal-entity/useSelectedLegalEntity';

export interface UseLockedRecipientTypeFilterResult {
  /** Id del tipo utente destinatario forzato, o undefined se nessun blocco. */
  lockedRecipientType: string[] | undefined;
}

/**
 * In sessione "per conto di" una Persona Giuridica il filtro Destinatario delle
 * domande è forzato al tipo utente coerente con il tipo della Persona Giuridica
 * (PRIVATA → "Persona giuridica", PUBBLICA → "Ente pubblico"). In sessione
 * Persona Fisica restituisce undefined (nessun blocco).
 */
export function useLockedRecipientTypeFilter(): UseLockedRecipientTypeFilterResult {
  const { selectedLegalEntity } = useSelectedLegalEntity();
  const { data: userKinds } = useGetFrontTipiUtente();

  const lockedRecipientType = useMemo<string[] | undefined>(() => {
    const legalEntityType = selectedLegalEntity?.tipoPg;
    if (!legalEntityType) return undefined;

    const code = recipientCodeByLegalEntityType[legalEntityType];
    if (!code) return undefined;

    const match = userKinds?.find(userKind => userKind.codice === code);

    if (!match?.id) {
      if (userKinds) {
        console.warn(
          `Nessun tipo utente con codice "${code}" per Persona Giuridica ${legalEntityType}: filtro Destinatario non bloccato.`,
        );
      }
      return undefined;
    }

    return [match.id];
  }, [selectedLegalEntity?.tipoPg, userKinds]);

  return { lockedRecipientType };
}
